<template>
  <div class="live-record" v-loading="loading" element-loading-text="视频加载中...">
    <video ref="videoRef" :src="video_url" preload="auto" controls></video>
  </div>
</template>

<script>
export default {
  data() {
    return {
      video_url: this.$route.query.url,
      loading: false,
    };
  },

  mounted() {
    // this.setVideoDuration();
  },

  methods: {
    setVideoDuration() {
      this.loading = true;
      const video = this.$refs.videoRef;

      if (!video) {
        this.loading = false;
        return;
      }

      video.onloadedmetadata = () => {
        if (video.duration === Infinity) {
          // 强制让浏览器计算 duration
          video.currentTime = 1e101; // 跳到超大时间（自动跳到视频末尾）

          video.ontimeupdate = () => {
            video.ontimeupdate = null; // 移除监听，避免死循环
            video.currentTime = 0; // 跳回开头
            this.loading = false;
          };
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.live-record {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000000;

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
